function embedInDom(value){
  const parser = new DOMParser()
  return parser.parseFromString(value, "text/html")
}

function findByTagAndExtractValue (domElem, searchTag){
  return domElem.querySelector(searchTag)
}

export function extractValueFromString(value){
  let  parsedValueInDOM = embedInDom(value)

  let link = findByTagAndExtractValue(parsedValueInDOM, "a")
  let notLink = link === null && findByTagAndExtractValue(parsedValueInDOM, "body")

  if(link) {
    return +link.innerHTML.replace(/[%$,]/g, "")
  }
  
  return notLink.innerHTML
}
